import { detectUnreadableFileContainer } from '@/shared/lib/detectUnreadableFileContainer'
import { MAX_UPLOAD_FILE_SIZE_BYTES } from '@/shared/lib/uploadGuardrails'
import { isAllowedProductSourceFile } from '@/features/product-catalog/utils/productSourceFileTypes'

export type ProductSourceUploadIneligibilityReason =
  | 'unsupported-type'
  | 'too-large'
  | 'encrypted'
  | 'rights-protected'
  | 'invalid-pdf'

export type ProductSourceUploadEligibility = {
  file: File
  eligible: boolean
  reason?: ProductSourceUploadIneligibilityReason
}

export async function assessProductSourceUploadEligibility(
  file: File
): Promise<ProductSourceUploadEligibility> {
  if (!isAllowedProductSourceFile(file)) {
    return { file, eligible: false, reason: 'unsupported-type' }
  }
  if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
    return { file, eligible: false, reason: 'too-large' }
  }
  const detection = await detectUnreadableFileContainer(file)
  if (detection.kind === 'invalid-pdf') {
    return { file, eligible: false, reason: 'invalid-pdf' }
  }
  if (detection.kind === 'rights-protected') {
    return { file, eligible: false, reason: 'rights-protected' }
  }
  if (detection.kind === 'encrypted') {
    return { file, eligible: false, reason: 'encrypted' }
  }
  return { file, eligible: true }
}

export async function assessProductSourceUploadEligibilityBatch(
  files: File[]
): Promise<ProductSourceUploadEligibility[]> {
  return Promise.all(files.map((file) => assessProductSourceUploadEligibility(file)))
}
